import { FC, useEffect, useState } from 'react';
import style from './CoatingPageStyle.module.css';
import { CoatingStep1 } from './CoatingStep1/CoatingStep1';
import { CoatingStep2 } from './CoatingStep2/CoatingStep2';
import { CoatingStep3 } from './CoatingStep3/CoatingStep3';
import { CoatingStep4 } from './CoatingStep4/CoatingStep4';
import { PopupCancel } from './PopupCancel/PopupCancel';
import { CustomBgPageTemplate } from '@/components/uiParts/Template/CustomBgPageTemplate/CustomBgPageTemplate';
import { coatingSteps } from '@/consts/coating';
import { useCoating } from '@/hooks/api/coating/useCoating';

type CoatingPageProp = {
  status?: string;
};

export const CoatingPage: FC<CoatingPageProp> = ({ status }) => {
  const [opened, setOpened] = useState(false);
  const {
    step,
    step1Data,
    step2Data,
    step3Data,
    courseItems,
    optionItems,
    coatingUnits,
    totalFee,
    totalWorkingMinutes,
    isGmoProcessing,
    customerEmail,
    setStep,
    submitStep1,
    submitStep2,
    submitStep3,
    submitStep4WithMethod,
    retryCreateCoating,
  } = useCoating(status);

  const handleClickBack = () => {
    // 決済済みの場合は前Stepへの遷移を禁止（編集内容と決済額の不整合を防止）
    if (status === 'gmo_success') {
      setOpened(true);
      return;
    }
    if (step === coatingSteps.PRE_SELECTION) {
      setOpened(true);
      return;
    }
    setStep(step - 1);
  };

  // 選択中のコース（Step3のキャンセル料表示用）
  const selectedCourse = courseItems.find(
    (c) => c.code === step1Data.coatingItemCode,
  );

  useEffect(() => {
    document.querySelector('.page-content > div > div')?.scrollTo(0, 0);
  }, [step]);

  return (
    <CustomBgPageTemplate
      pageName="Coating"
      title={
        step === coatingSteps.REVIEW ? '予約内容の確認' : 'ボディコーティング'
      }
      className={style['page']}
      handleClickBack={handleClickBack}
      background={{ background: '#fff' }}
      showNavBack
    >
      <PopupCancel
        closeOnEscape={false}
        closeByBackdropClick={false}
        status={status}
        opened={opened}
        onPopupClosed={() => setOpened(false)}
      />
      {step === coatingSteps.PRE_SELECTION && (
        <CoatingStep1
          step1Data={step1Data}
          courseItems={courseItems}
          optionItems={optionItems}
          onSubmit={(data, fee, workingMinutes) =>
            submitStep1(data, fee, workingMinutes)
          }
          onClickCancel={() => setOpened(true)}
        />
      )}
      {step === coatingSteps.REGISTATION && (
        <CoatingStep2
          step2Data={step2Data}
          coatingUnits={coatingUnits}
          workingMinutes={totalWorkingMinutes}
          customerEmail={customerEmail}
          onSubmit={submitStep2}
          onClickCancel={() => setOpened(true)}
        />
      )}
      {step === coatingSteps.ADDITIONAL_INFO && (
        <CoatingStep3
          courseItem={selectedCourse}
          step3Data={step3Data}
          onSubmit={submitStep3}
          onClickCancel={() => setOpened(true)}
        />
      )}
      {step === coatingSteps.REVIEW && !isGmoProcessing && (
        <CoatingStep4
          step1Data={step1Data}
          step2Data={step2Data}
          step3Data={step3Data}
          courseItems={courseItems}
          optionItems={optionItems}
          totalFee={totalFee}
          customerEmail={customerEmail}
          onSubmit={status === 'gmo_success' ? retryCreateCoating : () => {}}
          onSubmitWithMethod={
            status === 'gmo_success' ? undefined : submitStep4WithMethod
          }
          submitLabel={status === 'gmo_success' ? '予約を作成する' : undefined}
          hidePaymentMethodSelector={status === 'gmo_success'}
          onClickCancel={() => setOpened(true)}
        />
      )}
    </CustomBgPageTemplate>
  );
};
